import React, { useState } from "react";
import LoginPage from "./Pages/LoginPage/LoginPage";
import Admin from "./Layout/Admin";
import PlacePage from "./Pages/PlacePage/PlacePage";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import RoomPage from "./Pages/PlacePage/RoomPage";
function App(props) {
  require("dotenv").config();

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Router>
        <Switch>
          <Route path="/login" component={LoginPage} />{" "}
          <Route path="/place/:id" component={RoomPage} />
          <Route path="/place" component={PlacePage} />
          <Route path="/" component={Admin} />{" "}
        </Switch>
      </Router>
    </MuiPickersUtilsProvider>
  );
}
export default App;
